module.exports = __webpack_public_path__ + "static/media/horizontal_logo.0dae2b78.png";